/*
 * src/components/TransferHistory/TransferEditTooltip.jsx
 * Description: A simple tooltip component for editing a draft
 * Copyright (c) 2021 PredictiveUX
 */
import React from "react";
import { Link } from "react-router-dom";

import CustomTooltip from "../CustomTooltip/CustomTooltip";

const TransferEditTooltip = ({
  transferId,
  status,
  popoverText = "You can continue editing the transfer",
}) => {
  const content = (
    <Link
      className="transfer-history__link-draft"
      id="draft"
      to={`/create-account/step-select-account?go_to_transfer=${transferId}`}
    >
      {status}
    </Link>
  );

  return (
    <CustomTooltip
      popoverText={popoverText}
      content={content}
      type="blue"
    ></CustomTooltip>
  );
};

export default TransferEditTooltip;
